import { useRouteError } from "react-router";
import { AppErrorScreen } from "./AppErrorScreen";

interface Props {
  /** See {@link AppErrorScreen}: true where no shell surrounds the screen. */
  fullScreen?: boolean;
}

/** React Router `errorElement` (BUG-745): renders the branded error screen. */
export function RouteErrorElement({ fullScreen = false }: Props) {
  const error = useRouteError();
  return <AppErrorScreen error={error} fullScreen={fullScreen} />;
}
